module.exports = __webpack_public_path__ + "assets/img/culture.634ffa9e.png";